import {
    Avatar,
    componentStyles,
    Text,
    HorizontalStackSmallGap,
    SIZES,
} from "@mallardbay/lib-react-components"
import { faEarthAsia } from "@fortawesome/free-solid-svg-icons/faEarthAsia"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

import type { PortalTypeForContext } from "~contexts/outfitter-provider"
import {
    getSelectPlaceholder,
    type SelectedEntity as SelectedEntityType,
} from "~components/shared/portal-entity-selector/portal-entity-selector-helpers"
import { TEST_IDS } from "~config/constants"

interface Props {
    readonly portalType: PortalTypeForContext
    readonly selectedEntity: SelectedEntityType | null
    readonly shouldRender?: boolean
}

export default function SelectedEntity({
    portalType,
    selectedEntity,
    shouldRender = true,
}: Props) {
    const styles = useStyles()
    const placeholder = getSelectPlaceholder({ portalType })

    if (!shouldRender) return null
    if (!selectedEntity) return <Text style={styles.text}>{placeholder}</Text>

    return (
        <HorizontalStackSmallGap testId={TEST_IDS.PORTAL_SELECTED_ENTITY}>
            {selectedEntity.isAllSelectedEntity ? (
                <FontAwesomeIcon icon={faEarthAsia} style={styles.avatar} />
            ) : (
                <Avatar
                    name={selectedEntity.name}
                    src={selectedEntity.avatar}
                    size={SIZES.XS}
                    style={styles.avatar}
                />
            )}
            <Text style={styles.text}>{selectedEntity.name}</Text>
        </HorizontalStackSmallGap>
    )
}

function useStyles() {
    return componentStyles({
        avatar: {
            width: "20px",
            height: "20px",
        },
        text: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
    })
}
